export class VcaAlarm {
    public id: string;
    public state: string;
    public severity: string;
    public type: string;
    public message: string[];
    public module: string;
    public data: any;
    public location: string;
    constructor(data: any, message: any, id: string, state: string, severity: string, module: string, type: string, location?: string) {
        this.location = location ? location : 'main_alarm';
    }
}



// WEBPACK FOOTER //
// ./src/common/vca-alarms/vca-alarm.ts